// components/rapport/reportspages/players/DownloadPlayerPositionPdfButton.jsx
import { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import { Download } from "lucide-react";
import { usePdfExport } from "../../pdf/PdfExportContext";
import PlayersPositionReportPdf from "./PlayerPositionReportPdf";

async function toDataUrlIfHttp(url) {
  if (!url || !/^https?:\/\//i.test(String(url))) return url;
  try {
    const res = await fetch(url, { mode: "cors" });
    const blob = await res.blob();
    const reader = new FileReader();
    return await new Promise((resolve) => {
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch {
    return url; // fallback: on laisse l’URL telle quelle
  }
}

export default function DownloadPlayersPdfButton({ season }) {
  const [loading, setLoading] = useState(false);
  const exporter = usePdfExport();

  const handleDownload = async () => {
    setLoading(true);
    try {
      const images = exporter.getAllImages(); // "players.*"
      const data   = structuredClone(exporter.getAllData()); // __legend + players.table

      // Convertir avatars pour le PDF (si présents)
      const tbl = data?.["players.table"];
      if (tbl?.rows?.length) {
        await Promise.all(
          tbl.rows.map(async (r) => {
            if (r.avatar) r.avatar = await toDataUrlIfHttp(r.avatar);
          })
        );
      }

      const blob = await pdf(
        <PlayersPositionReportPdf
          season={season}
          images={images}
          data={data}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `players_positions_report_${season}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="flex items-center gap-1 px-3 py-2 text-sm font-medium rounded-lg bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-40"
      disabled={loading}
      title="Exporter le rapport joueurs/positions en PDF"
    >
      {loading ? (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="3" fill="none" />
        </svg>
      ) : <Download size={16} />}
      <span className="hidden md:inline">Exporter (PDF)</span>
    </button>
  );
}
